<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="('Call ' | translate) + pro?.first_name"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (clientPhone) {
      <tidy-row align="center">
        <tidy-text
          [body]="'Please use phone number on file:'" /><span>&nbsp;</span>
          <tidy-text
            [body]="clientPhone | telephone:'format'" />
        </tidy-row>
      }

      @if (!clientPhone) {
        <tidy-row align="center">
          <tidy-text
            [body]="'You have no phone number on file. Please add a phone number to call your pro.'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'Add Phone Number'"
              class="link"
              (action)="goToAddPhoneNumber()" />
          </tidy-row>
        }

        <tidy-button
          [action]="boundCallPro"
          [text]="('Call ' | translate) + pro?.first_name"
          [disabled]="!clientPhone"
          class="primary" />

      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
